import { PrivilegeEnum as a } from "@hprofits/shared/auth";
import { z as e } from "zod";
import { ocPrivate as t } from "../common/auth/procedure-builders.js";
import "../swagger/security.js";
import { SwaggerTags as r } from "../swagger/tags.js";
import { SspBalancesSchema as s, AdvertiserBalancesSchema as o, ModerationCountsSchema as n } from "./schemas.js";
const h = {
  dashboard: {
    moderationCounts: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dashboard/moderation-counts",
      summary: "Count the creatives, landings, payments and sites waiting for review",
      tags: [r.DASHBOARD.name]
    }).input(e.object({})).output(n).errors({}),
    advertiserBalances: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dashboard/advertiser-balances",
      summary: "List advertisers with balance alerts whose balance is $50 or less",
      tags: [r.DASHBOARD.name]
    }).input(e.object({})).output(o).errors({}),
    sspBalances: t([a.ReadAdmin]).route({
      method: "GET",
      path: "/dashboard/ssp-balances",
      summary: "List ad exchange users with external payments and their balance",
      tags: [r.DASHBOARD.name]
    }).input(e.object({})).output(s).errors({})
  }
};
export {
  h as dashboardContract
};
//# sourceMappingURL=contract.js.map
